import { Directive, DirectiveBinding } from 'vue'
import { usePermissionStore } from '@/stores/permission-store'

export const permissionDirective: Directive = {
  async beforeMount(el: HTMLElement, binding: DirectiveBinding) {
    const permissionStore = usePermissionStore()
    const requiredPermissions: string[] = binding.value.split(',').map((permission: string) => permission.trim())

    // Check all permissions
    const results = await Promise.all(
      requiredPermissions.map((permission) => permissionStore.hasPermission(permission)),
    )

    // Must be at least one
    const hasAnyPermission = results.some((result) => result)

    if (!hasAnyPermission) {
      el.remove()
    }
  },
}
